module.exports = "/_next/static/images/381042b18b7ac94e06bd4d68d3e3be19-credit-card-lg.svg.webp";